var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roleManage" } }, [
    _c("div", { staticClass: "dialog-content" }, [
      _vm.action === "edit"
        ? _c("div", { staticClass: "context" }, [
            _vm._v(
              "To edit a user role permissions, you can select or deselect the specific role permissions below."
            )
          ])
        : _vm.action === "selected-unit"
          ? _c("div", { staticClass: "context" }, [
              _vm._v(
                "\n      To add an existing user to this unit, select a user and a role. You may customize the user's specific role by selecting or deselecting role permissions. You can also "
              ),
              _c(
                "span",
                { staticClass: "vo-link", on: { click: _vm.inviteNewUser } },
                [_vm._v("invite a new user")]
              ),
              _vm._v(" to this unit.\n    ")
            ])
          : _c("div", { staticClass: "context" }, [
              _vm._v(
                "To add a new user role, start by choose the role template that is necessary. You may customize the user's specific role by selecting or deselecting role permissions."
              )
            ]),
      _vm._v(" "),
      _c("div", { staticClass: "title-area" }, [_vm._v("User / Role")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section" },
        [
          _vm.action === "selected-unit"
            ? _c("v-select", {
                ref: "selectUser",
                attrs: {
                  "prepend-icon": "mdi-account-circle",
                  label: "User",
                  autocomplete: "",
                  "item-text": "fullName",
                  "item-value": "_id",
                  loading: _vm.usersLoading,
                  rules: _vm.rules.user,
                  "search-input": _vm.userSearch,
                  items: _vm.users
                },
                on: {
                  "update:searchInput": function($event) {
                    _vm.userSearch = $event
                  }
                },
                model: {
                  value: _vm.user,
                  callback: function($$v) {
                    _vm.user = $$v
                  },
                  expression: "user"
                }
              })
            : _c("v-text-field", {
                attrs: {
                  label: _vm.user.fullName,
                  "prepend-icon": "mdi-account-circle",
                  disabled: ""
                }
              }),
          _vm._v(" "),
          _vm.role
            ? _c("v-select", {
                ref: "selectRole",
                attrs: {
                  label:
                    _vm.action === "edit" ? _vm.role.title : "Role Template",
                  "prepend-icon": "mdi-clipboard-account",
                  disabled: _vm.action === "edit",
                  "item-text": "title",
                  rules: _vm.rules.role,
                  items: _vm.roleTemplates
                },
                model: {
                  value: _vm.role.parent,
                  callback: function($$v) {
                    _vm.$set(_vm.role, "parent", $$v)
                  },
                  expression: "role.parent"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title-area" }, [_vm._v("Permissions")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "section", class: { disabled: !_vm.role.parent } },
        [
          _c(
            "div",
            {
              staticClass: "subtitle",
              staticStyle: { "margin-bottom": "16px" }
            },
            [_vm._v("Access Level")]
          ),
          _vm._v(" "),
          !_vm.role.parent && _vm.action !== "selected-unit"
            ? _c("div", { staticClass: "access-level" }, [
                _vm._v("Select a role template...")
              ])
            : _c(
                "div",
                [
                  _vm.accessLevel >= 3
                    ? _c("div", { staticClass: "access-level" }, [
                        _vm._v("All Properties")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.action === "edit" || _vm.action === "selected-unit"
                    ? [
                        _vm.role.property
                          ? _c("v-select", {
                              attrs: {
                                label: _vm.$store.getters.property(
                                  _vm.role.property
                                ).name,
                                "prepend-icon": "mdi-domain",
                                disabled: ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.role.unit
                          ? _c("v-select", {
                              attrs: {
                                label: _vm.$store.getters.unit(_vm.role.unit)
                                  .title,
                                "prepend-icon": "mdi-home",
                                disabled: ""
                              }
                            })
                          : _vm._e()
                      ]
                    : [
                        _vm.role.parent && _vm.role.parent.requires
                          ? [
                              _vm.role.parent.requires.property
                                ? _c("v-select", {
                                    ref: "selectProperty",
                                    attrs: {
                                      label: "Property",
                                      "prepend-icon": "mdi-domain",
                                      "item-text": "name",
                                      "item-value": "_id",
                                      rules: _vm.rules.property,
                                      items: _vm.properties
                                    },
                                    model: {
                                      value: _vm.role.property,
                                      callback: function($$v) {
                                        _vm.$set(_vm.role, "property", $$v)
                                      },
                                      expression: "role.property"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.role.parent.requires.unit
                                ? _c("v-select", {
                                    ref: "selectUnit",
                                    attrs: {
                                      "prepend-icon": "mdi-home",
                                      label: "Unit",
                                      autocomplete: "",
                                      "item-text": "title",
                                      "item-value": "_id",
                                      loading: _vm.unitsLoading,
                                      disabled: !_vm.role.property,
                                      rules: _vm.rules.unit,
                                      "search-input": _vm.unitSearch,
                                      items: _vm.units
                                    },
                                    on: {
                                      "update:searchInput": function($event) {
                                        _vm.unitSearch = $event
                                      }
                                    },
                                    model: {
                                      value: _vm.role.unit,
                                      callback: function($$v) {
                                        _vm.$set(_vm.role, "unit", $$v)
                                      },
                                      expression: "role.unit"
                                    }
                                  })
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                ],
                2
              ),
          _vm._v(" "),
          _c("vo-role-permissions", {
            ref: "rolePermissions",
            attrs: { accessLevel: _vm.accessLevel }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { disabled: _vm.lockout.on, flat: "", color: "info" },
            on: {
              click: function($event) {
                _vm.routeRemoveQueries(["dialog", "dialogAction", "dialogItem"])
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout.on, flat: "", color: "primary" },
            on: {
              click: function($event) {
                _vm.action === "edit" ? _vm.save() : _vm.create()
              }
            }
          },
          [_vm._v(_vm._s(_vm.action === "edit" ? "Save" : "Create"))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-852f83aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-852f83aa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoleManage.vue
// module id = 554
// module chunks = 4